import { createActionCreator } from "deox";
import { Transaction } from "../../../types/transaction";

export const transactionCreating = createActionCreator("transaction/creating");

export const transactionCreatingError = createActionCreator(
  "transaction/creatingError",
  (resolve) => (error: string) => resolve(error)
);

export const transactionCreated = createActionCreator(
  "transaction/created",
  (resolve) => (payload: number) => resolve(payload)
);

export const transactionDuplicate = createActionCreator(
  "transaction/duplicate",
  (resolve) => (duplicateId: number) => resolve(duplicateId)
);
